import React from 'react';
import PropTypes from 'prop-types';
import HomeMobile from './Mobile';
import HomeDesktop from './Desktop';
import { withMediaQueries } from '../../hoc/withMediaQueries';

const Home = ({ mediaIsPhone }) => {
  if (mediaIsPhone) return <HomeMobile />;
  return <HomeDesktop />;
};

Home.propTypes = {
  // HOC withMediaQueries
  mediaIsPhone: PropTypes.bool.isRequired,
};

export default withMediaQueries(Home);
